"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TupleTypeSpecifier = exports.NamedTypeSpecifier = exports.ListTypeSpecifier = exports.IntervalTypeSpecifier = exports.Is = exports.CanConvertQuantity = exports.ConvertQuantity = exports.ConvertsToTime = exports.ConvertsToString = exports.ConvertsToRatio = exports.ConvertsToQuantity = exports.ConvertsToInteger = exports.ConvertsToDecimal = exports.ConvertsToDateTime = exports.ConvertsToDate = exports.ConvertsToBoolean = exports.Convert = exports.ToTime = exports.ToString = exports.ToRatio = exports.ToQuantity = exports.ToInteger = exports.ToDecimal = exports.ToDateTime = exports.ToDate = exports.ToConcept = exports.ToBoolean = exports.As = void 0;
var expression_1 = require("./expression");
var datetime_1 = require("../datatypes/datetime");
var clinical_1 = require("../datatypes/clinical");
var quantity_1 = require("../datatypes/quantity");
var math_1 = require("../util/math");
var util_1 = require("../util/util");
var ratio_1 = require("../datatypes/ratio");
var uncertainty_1 = require("../datatypes/uncertainty");
// TODO: Casting and Conversion needs unit tests!
var As = /** @class */ (function (_super) {
    __extends(As, _super);
    function As(json) {
        var _this = _super.call(this, json) || this;
        if (json.asTypeSpecifier) {
            _this.asTypeSpecifier = json.asTypeSpecifier;
        }
        else if (json.asType) {
            // convert it to a NamedTypedSpecifier
            _this.asTypeSpecifier = {
                name: json.asType,
                type: 'NamedTypeSpecifier'
            };
        }
        _this.strict = json.strict != null ? json.strict : false;
        return _this;
    }
    As.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, argTypeString, asTypeString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        // If it is null, return null
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        if (ctx.matchesTypeSpecifier(arg, this.asTypeSpecifier)) {
                            // TODO: request patient source to change type identification
                            return [2 /*return*/, arg];
                        }
                        else if (this.strict) {
                            argTypeString = specifierToString(guessSpecifierType(arg));
                            asTypeString = specifierToString(this.asTypeSpecifier);
                            throw new Error("Cannot cast ".concat(argTypeString, " as ").concat(asTypeString));
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return As;
}(expression_1.Expression));
exports.As = As;
var ToBoolean = /** @class */ (function (_super) {
    __extends(ToBoolean, _super);
    function ToBoolean(json) {
        return _super.call(this, json) || this;
    }
    ToBoolean.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, strArg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            strArg = arg.toString().toLowerCase();
                            if (['true', 't', 'yes', 'y', '1'].includes(strArg)) {
                                return [2 /*return*/, true];
                            }
                            else if (['false', 'f', 'no', 'n', '0'].includes(strArg)) {
                                return [2 /*return*/, false];
                            }
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    return ToBoolean;
}(expression_1.Expression));
exports.ToBoolean = ToBoolean;
var ToConcept = /** @class */ (function (_super) {
    __extends(ToConcept, _super);
    function ToConcept(json) {
        return _super.call(this, json) || this;
    }
    ToConcept.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            return [2 /*return*/, new clinical_1.Concept([arg], arg.display)];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ToConcept;
}(expression_1.Expression));
exports.ToConcept = ToConcept;
var ToDate = /** @class */ (function (_super) {
    __extends(ToDate, _super);
    function ToDate(json) {
        return _super.call(this, json) || this;
    }
    ToDate.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        else if (arg.isDateTime) {
                            return [2 /*return*/, arg.getDate()];
                        }
                        else {
                            return [2 /*return*/, datetime_1.Date.parse(arg.toString())];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ToDate;
}(expression_1.Expression));
exports.ToDate = ToDate;
var ToDateTime = /** @class */ (function (_super) {
    __extends(ToDateTime, _super);
    function ToDateTime(json) {
        return _super.call(this, json) || this;
    }
    ToDateTime.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        else if (arg.isDate) {
                            return [2 /*return*/, arg.getDateTime()];
                        }
                        else {
                            return [2 /*return*/, datetime_1.DateTime.parse(arg.toString())];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ToDateTime;
}(expression_1.Expression));
exports.ToDateTime = ToDateTime;
var ToDecimal = /** @class */ (function (_super) {
    __extends(ToDecimal, _super);
    function ToDecimal(json) {
        return _super.call(this, json) || this;
    }
    ToDecimal.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, low, high, decimal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            if (arg.isUncertainty) {
                                low = (0, math_1.limitDecimalPrecision)(parseFloat(arg.low.toString()));
                                high = (0, math_1.limitDecimalPrecision)(parseFloat(arg.high.toString()));
                                return [2 /*return*/, new uncertainty_1.Uncertainty(low, high)];
                            }
                            else {
                                decimal = (0, math_1.limitDecimalPrecision)(parseFloat(arg.toString()));
                                if ((0, math_1.isValidDecimal)(decimal)) {
                                    return [2 /*return*/, decimal];
                                }
                            }
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    return ToDecimal;
}(expression_1.Expression));
exports.ToDecimal = ToDecimal;
var ToInteger = /** @class */ (function (_super) {
    __extends(ToInteger, _super);
    function ToInteger(json) {
        return _super.call(this, json) || this;
    }
    ToInteger.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, integer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (typeof arg === 'string') {
                            integer = parseInt(arg);
                            if ((0, math_1.isValidInteger)(integer)) {
                                return [2 /*return*/, integer];
                            }
                        }
                        else if (typeof arg === 'boolean') {
                            return [2 /*return*/, arg ? 1 : 0];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    return ToInteger;
}(expression_1.Expression));
exports.ToInteger = ToInteger;
var ToQuantity = /** @class */ (function (_super) {
    __extends(ToQuantity, _super);
    function ToQuantity(json) {
        return _super.call(this, json) || this;
    }
    ToQuantity.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.convertValue;
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
                }
            });
        });
    };
    ToQuantity.prototype.convertValue = function (val) {
        if (val == null) {
            return null;
        }
        else if (typeof val === 'number') {
            return new quantity_1.Quantity(val, '1');
        }
        else if (val.isRatio) {
            // numerator and denominator are guaranteed non-null
            return val.numerator.dividedBy(val.denominator);
        }
        else if (val.isUncertainty) {
            return new uncertainty_1.Uncertainty(this.convertValue(val.low), this.convertValue(val.high));
        }
        else {
            // it's a string or something else we'll try to parse as a string
            return (0, quantity_1.parseQuantity)(val.toString());
        }
    };
    return ToQuantity;
}(expression_1.Expression));
exports.ToQuantity = ToQuantity;
var ToRatio = /** @class */ (function (_super) {
    __extends(ToRatio, _super);
    function ToRatio(json) {
        return _super.call(this, json) || this;
    }
    ToRatio.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, denominator, numerator, splitRatioString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            denominator = void 0, numerator = void 0;
                            try {
                                splitRatioString = arg
                                    .toString()
                                    .match(/^(\d+(\.\d+)?\s*('.+')?)\s*:\s*(\d+(\.\d+)?\s*('.+')?)$/);
                                if (splitRatioString == null) {
                                    return [2 /*return*/, null];
                                }
                                numerator = (0, quantity_1.parseQuantity)(splitRatioString[1]);
                                denominator = (0, quantity_1.parseQuantity)(splitRatioString[4]);
                            }
                            catch (error) {
                                // If the input string is not formatted correctly, or cannot be
                                // interpreted as a valid Quantity value, the result is null.
                                return [2 /*return*/, null];
                            }
                            // The value element of a Quantity must be present.
                            if (numerator == null || denominator == null) {
                                return [2 /*return*/, null];
                            }
                            return [2 /*return*/, new ratio_1.Ratio(numerator, denominator)];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ToRatio;
}(expression_1.Expression));
exports.ToRatio = ToRatio;
var ToString = /** @class */ (function (_super) {
    __extends(ToString, _super);
    function ToString(json) {
        return _super.call(this, json) || this;
    }
    ToString.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            return [2 /*return*/, arg.toString()];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ToString;
}(expression_1.Expression));
exports.ToString = ToString;
var ToTime = /** @class */ (function (_super) {
    __extends(ToTime, _super);
    function ToTime(json) {
        return _super.call(this, json) || this;
    }
    ToTime.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg, timeString, matches, hours, minutes, seconds, milliseconds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            timeString = arg.toString();
                            matches = /^T?((\d{2})(:(\d{2})(:(\d{2})(\.(\d+))?)?)?)?(Z|(([+-])(\d{2})(:?(\d{2}))?))?$/.exec(timeString);
                            if (matches == null) {
                                return [2 /*return*/, null];
                            }
                            hours = matches[2];
                            minutes = matches[4];
                            seconds = matches[6];
                            // Validate h/m/s if they exist, but allow null
                            if (hours != null) {
                                if (hours < 0 || hours > 23) {
                                    return [2 /*return*/, null];
                                }
                                hours = parseInt(hours, 10);
                            }
                            if (minutes != null) {
                                if (minutes < 0 || minutes > 59) {
                                    return [2 /*return*/, null];
                                }
                                minutes = parseInt(minutes, 10);
                            }
                            if (seconds != null) {
                                if (seconds < 0 || seconds > 59) {
                                    return [2 /*return*/, null];
                                }
                                seconds = parseInt(seconds, 10);
                            }
                            milliseconds = matches[8];
                            if (milliseconds != null) {
                                milliseconds = parseInt((0, util_1.normalizeMillisecondsField)(milliseconds));
                            }
                            // Time is implemented as Datetime with year 0, month 1, day 1 and null timezoneOffset
                            return [2 /*return*/, new datetime_1.DateTime(0, 1, 1, hours, minutes, seconds, milliseconds, null)];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ToTime;
}(expression_1.Expression));
exports.ToTime = ToTime;
var Convert = /** @class */ (function (_super) {
    __extends(Convert, _super);
    function Convert(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        _this.toType = json.toType;
        return _this;
    }
    Convert.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (this.toType) {
                    case '{urn:hl7-org:elm-types:r1}Boolean':
                        return [2 /*return*/, new ToBoolean({ type: 'ToBoolean', operand: this.operand }).execute(ctx)];
                    case '{urn:hl7-org:elm-types:r1}Concept':
                        return [2 /*return*/, new ToConcept({ type: 'ToConcept', operand: this.operand }).execute(ctx)];
                    case '{urn:hl7-org:elm-types:r1}Decimal':
                        return [2 /*return*/, new ToDecimal({ type: 'ToDecimal', operand: this.operand }).execute(ctx)];
                    case '{urn:hl7-org:elm-types:r1}Integer':
                        return [2 /*return*/, new ToInteger({ type: 'ToInteger', operand: this.operand }).execute(ctx)];
                    case '{urn:hl7-org:elm-types:r1}String':
                        return [2 /*return*/, new ToString({ type: 'ToString', operand: this.operand }).execute(ctx)];
                    case '{urn:hl7-org:elm-types:r1}Quantity':
                        return [2 /*return*/, new ToQuantity({ type: 'ToQuantity', operand: this.operand }).execute(ctx)];
                    case '{urn:hl7-org:elm-types:r1}DateTime':
                        return [2 /*return*/, new ToDateTime({ type: 'ToDateTime', operand: this.operand }).execute(ctx)];
                    case '{urn:hl7-org:elm-types:r1}Date':
                        return [2 /*return*/, new ToDate({ type: 'ToDate', operand: this.operand }).execute(ctx)];
                    case '{urn:hl7-org:elm-types:r1}Time':
                        return [2 /*return*/, new ToTime({ type: 'ToTime', operand: this.operand }).execute(ctx)];
                    default:
                        return [2 /*return*/, this.execArgs(ctx)];
                }
                return [2 /*return*/];
            });
        });
    };
    return Convert;
}(expression_1.Expression));
exports.Convert = Convert;
var ConvertsToBoolean = /** @class */ (function (_super) {
    __extends(ConvertsToBoolean, _super);
    function ConvertsToBoolean(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToBoolean.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToBoolean, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToBoolean;
}(expression_1.Expression));
exports.ConvertsToBoolean = ConvertsToBoolean;
var ConvertsToDate = /** @class */ (function (_super) {
    __extends(ConvertsToDate, _super);
    function ConvertsToDate(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToDate.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToDate, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToDate;
}(expression_1.Expression));
exports.ConvertsToDate = ConvertsToDate;
var ConvertsToDateTime = /** @class */ (function (_super) {
    __extends(ConvertsToDateTime, _super);
    function ConvertsToDateTime(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToDateTime.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToDateTime, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToDateTime;
}(expression_1.Expression));
exports.ConvertsToDateTime = ConvertsToDateTime;
var ConvertsToDecimal = /** @class */ (function (_super) {
    __extends(ConvertsToDecimal, _super);
    function ConvertsToDecimal(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToDecimal.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToDecimal, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToDecimal;
}(expression_1.Expression));
exports.ConvertsToDecimal = ConvertsToDecimal;
var ConvertsToInteger = /** @class */ (function (_super) {
    __extends(ConvertsToInteger, _super);
    function ConvertsToInteger(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToInteger.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToInteger, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToInteger;
}(expression_1.Expression));
exports.ConvertsToInteger = ConvertsToInteger;
var ConvertsToQuantity = /** @class */ (function (_super) {
    __extends(ConvertsToQuantity, _super);
    function ConvertsToQuantity(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToQuantity.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToQuantity, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToQuantity;
}(expression_1.Expression));
exports.ConvertsToQuantity = ConvertsToQuantity;
var ConvertsToRatio = /** @class */ (function (_super) {
    __extends(ConvertsToRatio, _super);
    function ConvertsToRatio(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToRatio.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToRatio, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToRatio;
}(expression_1.Expression));
exports.ConvertsToRatio = ConvertsToRatio;
var ConvertsToString = /** @class */ (function (_super) {
    __extends(ConvertsToString, _super);
    function ConvertsToString(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToString.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToString, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToString;
}(expression_1.Expression));
exports.ConvertsToString = ConvertsToString;
var ConvertsToTime = /** @class */ (function (_super) {
    __extends(ConvertsToTime, _super);
    function ConvertsToTime(json) {
        var _this = _super.call(this, json) || this;
        _this.operand = json.operand;
        return _this;
    }
    ConvertsToTime.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var operatorValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        operatorValue = _a.sent();
                        if (operatorValue === null) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, canConvertToType(ToTime, this.operand, ctx)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertsToTime;
}(expression_1.Expression));
exports.ConvertsToTime = ConvertsToTime;
function canConvertToType(toFunction, operand, ctx) {
    return __awaiter(this, void 0, void 0, function () {
        var value, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, new toFunction({ type: toFunction.name, operand: operand }).execute(ctx)];
                case 1:
                    value = _a.sent();
                    if (value != null) {
                        return [2 /*return*/, true];
                    }
                    else {
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
var ConvertQuantity = /** @class */ (function (_super) {
    __extends(ConvertQuantity, _super);
    function ConvertQuantity(json) {
        return _super.call(this, json) || this;
    }
    ConvertQuantity.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, quantity, newUnit;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), quantity = _a[0], newUnit = _a[1];
                        if (quantity != null && newUnit != null) {
                            try {
                                return [2 /*return*/, quantity.convertUnit(newUnit)];
                            }
                            catch (error) {
                                // Cannot convert input to target unit, spec says to return null
                                return [2 /*return*/, null];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConvertQuantity;
}(expression_1.Expression));
exports.ConvertQuantity = ConvertQuantity;
var CanConvertQuantity = /** @class */ (function (_super) {
    __extends(CanConvertQuantity, _super);
    function CanConvertQuantity(json) {
        return _super.call(this, json) || this;
    }
    CanConvertQuantity.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, quantity, newUnit;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), quantity = _a[0], newUnit = _a[1];
                        if (quantity != null && newUnit != null) {
                            try {
                                quantity.convertUnit(newUnit);
                                return [2 /*return*/, true];
                            }
                            catch (error) {
                                return [2 /*return*/, false];
                            }
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    return CanConvertQuantity;
}(expression_1.Expression));
exports.CanConvertQuantity = CanConvertQuantity;
var Is = /** @class */ (function (_super) {
    __extends(Is, _super);
    function Is(json) {
        var _this = _super.call(this, json) || this;
        if (json.isTypeSpecifier) {
            _this.isTypeSpecifier = json.isTypeSpecifier;
        }
        else if (json.isType) {
            // Convert it to a NamedTypeSpecifier
            _this.isTypeSpecifier = {
                name: json.isType,
                type: 'NamedTypeSpecifier'
            };
        }
        return _this;
    }
    Is.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg === null) {
                            return [2 /*return*/, false];
                        }
                        if (typeof arg._is !== 'function' && !isSystemType(this.isTypeSpecifier)) {
                            // We need an _is implementation in order to check non System types
                            throw new Error("Patient Source does not support Is operation for localId: ".concat(this.localId));
                        }
                        return [2 /*return*/, ctx.matchesTypeSpecifier(arg, this.isTypeSpecifier)];
                }
            });
        });
    };
    return Is;
}(expression_1.Expression));
exports.Is = Is;
function isSystemType(spec) {
    switch (spec.type) {
        case 'NamedTypeSpecifier':
            return spec.name.startsWith('{urn:hl7-org:elm-types:r1}');
        case 'ListTypeSpecifier':
            return isSystemType(spec.elementType);
        case 'TupleTypeSpecifier':
            return spec.element.every(function (e) { return isSystemType(e.elementType); });
        case 'IntervalTypeSpecifier':
            return isSystemType(spec.pointType);
        case 'ChoiceTypeSpecifier':
            return spec.choice.every(function (c) { return isSystemType(c); });
        default:
            return false;
    }
}
function specifierToString(spec) {
    if (typeof spec === 'string') {
        return spec;
    }
    else if (spec == null || spec.type == null) {
        return '';
    }
    switch (spec.type) {
        case 'NamedTypeSpecifier':
            return spec.name;
        case 'ListTypeSpecifier':
            return "List<".concat(specifierToString(spec.elementType), ">");
        case 'TupleTypeSpecifier':
            return "Tuple<".concat(spec.element
                .map(function (e) { return "".concat(e.name, " ").concat(specifierToString(e.elementType)); })
                .join(', '), ">");
        case 'IntervalTypeSpecifier':
            return "Interval<".concat(specifierToString(spec.pointType), ">");
        case 'ChoiceTypeSpecifier':
            return "Choice<".concat(spec.choice.map(function (c) { return specifierToString(c); }).join(', '), ">");
        default:
            return JSON.stringify(spec);
    }
}
function guessSpecifierType(val) {
    if (val == null) {
        return 'Null';
    }
    var typeHierarchy = typeof val._typeHierarchy === 'function' && val._typeHierarchy();
    if (typeHierarchy && typeHierarchy.length > 0) {
        return typeHierarchy[0];
    }
    else if (typeof val === 'boolean') {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Boolean' };
    }
    else if (typeof val === 'number' && Math.floor(val) === val) {
        // it could still be a decimal, but we have to just take our best guess!
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Integer' };
    }
    else if (typeof val === 'number') {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Decimal' };
    }
    else if (typeof val === 'string') {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}String' };
    }
    else if (val.isConcept) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Concept' };
    }
    else if (val.isCode) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Code' };
    }
    else if (val.isDate) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Date' };
    }
    else if (val.isTime && val.isTime()) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}Time' };
    }
    else if (val.isDateTime) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}DateTime' };
    }
    else if (val.isQuantity) {
        return { type: 'NamedTypeSpecifier', name: '{urn:hl7-org:elm-types:r1}DateTime' };
    }
    else if (Array.isArray(val)) {
        // Get unique types from the array (by converting to string and putting in a Set)
        var typesAsStrings = Array.from(new Set(val.map(function (v) { return JSON.stringify(guessSpecifierType(v)); })));
        var types = typesAsStrings.map(function (ts) { return (/^{/.test(ts) ? JSON.parse(ts) : ts); });
        return {
            type: 'ListTypeSpecifier',
            elementType: types.length == 1 ? types[0] : { type: 'ChoiceTypeSpecifier', choice: types }
        };
    }
    else if (val.isInterval) {
        return {
            type: 'IntervalTypeSpecifier',
            pointType: val.pointType
        };
    }
    else if (typeof val === 'object' && Object.keys(val).length > 0) {
        return {
            type: 'TupleTypeSpecifier',
            element: Object.keys(val).map(function (k) { return ({ name: k, elementType: guessSpecifierType(val[k]) }); })
        };
    }
    return 'Unknown';
}
var IntervalTypeSpecifier = /** @class */ (function (_super) {
    __extends(IntervalTypeSpecifier, _super);
    function IntervalTypeSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IntervalTypeSpecifier;
}(expression_1.UnimplementedExpression));
exports.IntervalTypeSpecifier = IntervalTypeSpecifier;
var ListTypeSpecifier = /** @class */ (function (_super) {
    __extends(ListTypeSpecifier, _super);
    function ListTypeSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ListTypeSpecifier;
}(expression_1.UnimplementedExpression));
exports.ListTypeSpecifier = ListTypeSpecifier;
var NamedTypeSpecifier = /** @class */ (function (_super) {
    __extends(NamedTypeSpecifier, _super);
    function NamedTypeSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NamedTypeSpecifier;
}(expression_1.UnimplementedExpression));
exports.NamedTypeSpecifier = NamedTypeSpecifier;
var TupleTypeSpecifier = /** @class */ (function (_super) {
    __extends(TupleTypeSpecifier, _super);
    function TupleTypeSpecifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TupleTypeSpecifier;
}(expression_1.UnimplementedExpression));
exports.TupleTypeSpecifier = TupleTypeSpecifier;
//# sourceMappingURL=type.js.map